import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export const dummyAuthService: IAuthServiceV2 = {
	isAuthenticated: async () => false,

	login: async () => {},

	logout: async () => {},

	subscribe: () => {},

	fetch: async () => new Response(),

	get: async () => new Response(),

	put: async () => new Response(),

	post: async () => new Response(),

	patch: async () => new Response(),

	delete: async () => new Response(),

	continueSession: async () => false,
};
